import React from 'react';
import ContenedorError from './styles';
import ErrorImg from "../../../assets/img/user-error.svg";

const ErrorGenerico = () => {
  return (
    <div>
      <ContenedorError className="contenedor-error">
        <div className="error-info">
          <img src={ErrorImg} alt="error" />
          <h2>¡Lo sentimos!</h2>
          <p>En este momento el servicio no está disponible. Vuelve a intentarlo más tarde.</p>
        </div>
      </ContenedorError>
    </div>
  );
};

export default ErrorGenerico;
